
import React, { useEffect, useState } from "react";
import "./css/booking-detail.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, Link } from "react-router-dom";
import { setLoading } from "../../../features/common/bookingSlice";
import { getBookingDetailById, getBookingPdf, getHotelBookingDetailById, getHotelBookingPdf } from "../../../services/userservice";
import * as moment from "moment";
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
// import 'leaflet/dist/leaflet.css'; // Required for map styling
// import L from 'leaflet';
// import markerIcon from 'leaflet/dist/images/marker-icon.png';
// import markerShadow from 'leaflet/dist/images/marker-shadow.png';

const BookingHotelDetail = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [bookingData, setBookingData] = useState(null);
    const [loading, setLoading] = useState(null);

    useEffect(() => {
        fetchBookingData(id);
    }, []);

    const fetchBookingData = (id) => {
        setLoading(true);
        getHotelBookingDetailById(id)
            .then((response) => {
                setBookingData(response?.bookingData);
            })
            .catch((error) => {
                console.log("error", error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const [loader, setLoader] = useState(null);

    const generatePdf = async () => {
        setLoader(true)
        try {
            const response = await getHotelBookingPdf(id);
            setLoader(false)
            const file = new Blob([response], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(file);
            link.download = 'ticket.pdf';
            link.click();
            URL.revokeObjectURL(link.href);

        } catch (error) {
            setLoader(false)
            console.error('Error downloading the PDF:', error);
        }

    }
    // const DefaultIcon = L.icon({
    //     iconUrl: markerIcon,
    //     shadowUrl: markerShadow,
    // });

    // L.Marker.prototype.options.icon = DefaultIcon;
    // const latitude = bookingData?.[0]?.latitude;
    // const longitude = bookingData?.[0]?.longitude;
    // const position = latitude && longitude ? [latitude, longitude] : null;


    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1>Booking Detail</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <a href="#">Home</a>
                                </li>
                                <li className="breadcrumb-item active">Booking Detail</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="invoice p-3 mb-3">
                                {/* title row */}
                                <div className="row">
                                    <div className="col-6">
                                        <h4>
                                            <i className="fas fa-globe" />
                                        </h4>
                                    </div>
                                    <div className="col-6">
                                        <h4>
                                            <small><b>Date:</b> {moment(bookingData?.booking_date).format("LLLL")}</small>
                                        </h4>
                                    </div>
                                </div>
                                <div className="row invoice-info">
                                    <div className="col-sm-6 invoice-col">
                                        <div className="smt_invoice_left">
                                            From
                                            <address>
                                                <strong>SUPERB WORLD TRIP</strong>
                                                <br />
                                                SECOND FLOOR NEHRU HOUSE
                                                <br />
                                                4 BAHADUR SHAH ZAFAR MARG ITO
                                                <br />
                                                NEW DELHI, INDIA
                                                <br />
                                                Phone: (+91) 9312241999
                                                <br />
                                                Email: booking@superbworldtrip.com
                                            </address>
                                        </div>
                                    </div>

                                    <div className="col-sm-6 invoice-col">
                                        <div className="smt_invoice_left">
                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                <b style={{ width: '30%' }}>Hotel Name:</b>
                                                <address style={{ width: '70%', marginBottom: '0' }}>
                                                    <strong>{bookingData?.[0]?.hotel_name}</strong>
                                                </address>
                                            </div>
                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                <b style={{ width: '30%' }}>Address:</b>
                                                <address style={{ width: '70%', marginBottom: '0' }}>
                                                    {bookingData?.[0]?.hotel_address}
                                                </address>
                                            </div>
                                           

                                            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                            <b style={{ width: '30%' }}>Booking Status:</b>
                                            <div style={{ width: '70%', marginBottom: 0 }}>
                                                {bookingData?.[0]?.booking_status?.toLowerCase() === 'success' ||
                                                bookingData?.[0]?.booking_status?.toLowerCase() === 'confirmed' ? (
                                                <span style={{ color: 'green', fontWeight: 'bold' }}>Confirmed</span>
                                                ) : (
                                                <span style={{ color: 'red', fontWeight: 'bold' }}>Not Confirmed</span>
                                                )}
                                            </div>
                                            </div>
{/* 
                                            <div>
                                                <b>Map Location:</b>
                                                <div>
                                                    {position ? (
                                                        <MapContainer
                                                            center={position}
                                                            zoom={13}
                                                            style={{ height: '120px', width: '100%', borderRadius: '10px' }}
                                                            className="mb-4"
                                                        >
                                                            <TileLayer
                                                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                                            />
                                                            <Marker position={position}>
                                                                <Popup>
                                                                    {bookingData?.[0]?.hotel_address}
                                                                </Popup>
                                                            </Marker>
                                                        </MapContainer>
                                                    ) : (
                                                        <p>Loading map...</p>
                                                    )}
                                                </div>
                                            </div> */}

                                        </div>
                                    </div>
                                </div>


                                <div className="row">
                                    <div className="col-12">
                                        <table className="table table-striped border-bottom mb-4">
                                            {/* <thead>
                                                <tr><th class="smt_width_6 smt_semi_bold smt_primary_color smt_gray_bg" colspan="5">Passenger Information</th></tr>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Name</th>
                                                    <th>Contact No. </th>
                                                    <th>Email</th>
                                                </tr>
                                            </thead> */}
                                            {/* <tbody>
                                                {bookingData?.[0]?.guestData?.map((passenger, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td className="text-capitalize">
                                                            {passenger?.first_name} {passenger?.last_name}
                                                        </td>
                                                        <td>{passenger?.swt_user_id ? bookingData[0]?.billing_phone_no : "---"}</td>
                                                        <td>{passenger?.swt_user_id ? bookingData[0]?.billing_email : "---"}</td>
                                                    </tr>
                                                ))}
                                            </tbody> */}
                                        </table>
                                    </div>
                                    <hr />
                                    <div className="col-12">
                                        <div className="table-responsive">
                                        <table className="table table-striped border-bottom mb-4">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Name</th>
                                                    <th>Check-in/Check-out</th>
                                                    <th>Room Type/ Plan Details</th>
                                                    {/* <th>Amount Including All Taxes</th> */}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {bookingData?.[0]?.rooms?.map((room, roomIndex) => (
                                                    <tr key={roomIndex}>
                                                        <td>{roomIndex + 1}</td>
                                                         <td style={{ whiteSpace: 'nowrap' }}>
                                                            {room?.passengers?.map((passenger, index) => (
                                                            <div key={index}>
                                                                {passenger.title} {passenger.first_name} {passenger.last_name}
                                                            </div>
                                                            ))}
                                                        </td>
                                                        <td className="text-capitalize">
                                                            {moment(bookingData?.[0]?.from_date).format("DD MMM YYYY")} - {moment(bookingData?.[0]?.to_date).format("DD MMM YYYY")}
                                                        </td>
                                                        <td>
                                                            {room?.room_type_name}
                                                        </td>
                                                        {/* <td>
                                                            {`${bookingData?.[0]?.total_amount / bookingData?.[0]?.rooms.length} INR`}
                                                        </td> */}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    </div>
                                </div>

                               
                                <hr />

                                <div className="row " style={{ marginTop: '10px' }}>
                                    <div className="col-md-12">
                                        <h6><b>Booking Terms & Conditions</b></h6>
                                        <ul>
                                            <li>You must present a photo ID at the time of check in. Hotel may ask for credit card or cash deposit for the extra services at the time of check in.</li>
                                            <li>All extra charges should be collected directly from clients prior to departure such as parking, phone calls, room service, city tax, etc.</li>
                                            <li>We don't accept any responsibility for additional expenses due to the changes or delays in air, road, rail, sea or indeed of any other causes, all such expenses will have to be borne by passengers.</li>
                                            <li>In case of wrong residency & nationality selected by user at the time of booking; the supplement charges may be applicable and need to be paid to the hotel by guest on check in/ check out.</li>
                                            <li>Any special request for bed type, early check in, late check out, smoking rooms, etc are not guaranteed as subject to availability at the time of check in.</li>
                                            <li>Early check out will attract full cancellation charges unless otherwise specified.</li>
                                        </ul>
                                    </div>
                                </div>
                                <hr />

                                <div className="row " style={{ marginTop: '10px' }}>
                                    <div className="col-md-12 my-4">
                                        <h6><b>Hotel Policies</b></h6>
                                        {bookingData?.[0]?.hotel_policy}
                                    </div>
                                </div>
                                <hr />

                                <div className="row" style={{ marginTop: '20px' }}>
                                    <div className="col-md-6">
                                        <h6>Booking ID: <b>{bookingData?.[0]?.swt_booking_id}</b></h6>
                                        <p className="mb-0">Booking Details for: {bookingData?.[0]?.hotel_name}</p>
                                        <p className="mb-0">Booking Date: {moment(bookingData?.[0]?.created_at).format("LL")} </p>
                                        <p className="mb-0">Billing Email: {bookingData?.[0]?.billing_email}</p>
                                        
                                    </div>
                                    <div className="col-md-6">
                                        <p class="smt_mb2"><b class="smt_primary_color">Room Information:</b></p>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td class="smt_width_3 smt_primary_color smt_border_none smt_pb5">Room Type:  </td>
                                                    <td class="smt_width_3 smt_primary_color smt_text_right smt_border_none smt_pb5">
                                                        <b>{bookingData?.[0]?.rooms?.[0]?.room_type_name}</b>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="smt_width_3 smt_primary_color smt_border_none smt_pt0 smt_pb5">Check-in:  </td>
                                                    <td class="smt_width_3 smt_primary_color smt_text_right smt_border_none smt_pt0 smt_pb5">
                                                        <b>{moment(bookingData?.[0]?.from_date).format("DD MMM YYYY")}</b>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="smt_width_3 smt_primary_color smt_border_none smt_pt0 smt_pb5">Check-out:  </td>
                                                    <td class="smt_width_3 smt_primary_color smt_text_right smt_border_none smt_pt0 smt_pb5">
                                                        <b>{moment(bookingData?.[0]?.to_date).format("DD MMM YYYY")}</b>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="smt_width_3 smt_primary_color smt_border_none smt_pt0 smt_pb5">Smoking Preference: </td>
                                                    <td class="smt_width_3 smt_primary_color smt_text_right smt_border_none smt_pt0 smt_pb5">
                                                        <b>{bookingData?.[0]?.rooms?.[0]?.smoking_preference === 3 ? 'No Preference' : 'Specified'}</b>
                                                    </td>
                                                </tr>
                                                <tr className="smt_border_top">
                                                    <td class="smt_width_3 smt_border_top_0 smt_bold smt_f16 smt_primary_color">Total Amount:  </td>
                                                    <td class="smt_width_3 smt_border_top_0 smt_bold smt_f16 smt_primary_color smt_text_right">
                                                        <b>{bookingData?.[0]?.total_amount}</b>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>






                                <div className="row no-print">
                                    <div className="col-12">

                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            style={{ marginRight: 5 }}
                                            onClick={generatePdf}
                                            disabled={loader}
                                        >
                                            <i className="fas fa-download" /> Generate PDF

                                        </button>


                                        {/* {loader && <span>Please wait ...</span>} */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default BookingHotelDetail;
